import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { PropType } from 'vue'
import { PPTVideoElement } from '@/types/slides'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseVideoElement',
  props: {
  elementInfo: {
    type: Object as PropType<PPTVideoElement>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_IconPlayOne = _resolveComponent("IconPlayOne")!

  return (_openBlock(), _createElementBlock("div", {
    class: "base-element-video",
    style: _normalizeStyle({
      top: __props.elementInfo.top + 'px',
      left: __props.elementInfo.left + 'px',
      width: __props.elementInfo.width + 'px',
      height: __props.elementInfo.height + 'px',
    })
  }, [
    _createElementVNode("div", {
      class: "rotate-wrapper",
      style: _normalizeStyle({ transform: `rotate(${__props.elementInfo.rotate}deg)` })
    }, [
      _createElementVNode("div", {
        class: "element-content",
        style: _normalizeStyle({ backgroundImage: `url(${__props.elementInfo.poster})` })
      }, [
        _createVNode(_component_IconPlayOne, { class: "icon" })
      ], 4)
    ], 4)
  ], 4))
}
}

})